import { useState } from 'react'
import eyeSvg from '../../../assets/images/icons/eye.svg'
import { Icon } from '../../atoms'
import type { InputPropsType } from '../../atoms/Input'
import { InputWrapper } from '../InputWrapper'
import { inputWrapped } from './index.css'

export const InputPassword = (
  props: Omit<InputPropsType<'text' | 'password'>, 'type'> & {
    onChange?: (value: string | undefined) => void
  },
) => {
  const [isVisible, setIsVisible] = useState(false)

  const onClickEye: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.stopPropagation()
    setIsVisible((s) => !s)
  }

  return (
    <InputWrapper
      {...props}
      classNameWrapped={inputWrapped}
      type={isVisible ? 'text' : 'password'}
    >
      <Icon
        src={eyeSvg}
        style={{ opacity: isVisible ? '0.5' : '1' }}
        analytic={{
          name: 'password_eye',
        }}
        onClick={onClickEye}
      />
    </InputWrapper>
  )
}
